import "./App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";

/**
 * Toggles a `mt-bg-hidden` class on <body> whenever the tab becomes hidden.
 * CSS uses that class to pause every decorative animation so background
 * audio doesn't drain battery / heat the device unnecessarily.
 */
function useBackgroundPauseClass() {
  useEffect(() => {
    if (typeof document === "undefined") return undefined;
    const apply = () => {
      if (document.hidden) document.body.classList.add("mt-bg-hidden");
      else document.body.classList.remove("mt-bg-hidden");
    };
    apply();
    document.addEventListener("visibilitychange", apply);
    return () => document.removeEventListener("visibilitychange", apply);
  }, []);
}

function App() {
  useBackgroundPauseClass();
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
